export const EDITABLE_ITEM = 11;
export const timeTillEditIsAllowed = '11:00 am';
export const KEY_BACKSPACE = 8;
export const KEY_DELETE = 46;
export const KEY_F2 = 113;
export const KEY_ENTER = 13;
export const KEY_TAB = 9;
export const KEY_ESC = 27;
export const KEY_LEFT = 37;
export const KEY_RIGHT = 38;
export const SUBSEQUENT_NUMBERS = '1234567890';

export const SENSAI_PAGE_PARAMS = 'senseiPageParams';
export const COMMITMENT_TABLE = 'commitmentTable';
export const PTP_DETAIL_TABLE = 'ptpDetailTable';
export const SELECTED_AGENT_ID = 'agentId';
export const SELECTED_PTP_STATUS = 'ptpStatus';
export const COMMITMENT_DATE = 'date';
export const PAGE_NUMBER = 'pageNumber';
export const NO_REASONS = 'No Reason';
export const INPUT_TABLE = 'inputTable';
export const OUTPUT_TABLE = 'outputTable';
export const OVERALL_METRIC_FILTERS = 'overallMetricFilters';
export const OUTPUT_TABLE_SORT_KEY = 'outputTableSortKey';
export const OUTPUT_TABLE_SORT_ORDER = 'outputTableSortOrder';

export const NUMBER = 'number';
export const ARRAY = 'array';

export enum EditableColumns {
  cashCommitted = 'cashCommitted',
  visitsCommitted = 'visitsCommitted',
  reasonsForCashDeviation = 'reasonsForCashDeviation',
  reasonsForVisitDeviation = 'reasonsForVisitDeviation',
  remarks = 'remarks',
  agencyName = 'agencyName'
}

export const CellEditingNumberParams = {
  cashCollected: NUMBER,
  cashCommitted: NUMBER,
  visitsCommitted: NUMBER,
  visits: NUMBER
};
export const CellEditingArrayParams = {
  reasonsForCashDeviation: ARRAY,
  reasonsForVisitDeviation: ARRAY
};

export const DEFAULT_PAGE_NUMBER = 1;
export const DEFAULT_PAGE_SIZE = 10;
export const TABLE_HEIGHT = 675;
export const DAILY_PLANNING_TABLE_HEIGHT = 619;
export const DEFAULT_SORT_ORDER = 'ASC';
export const BE_DEFAULT_PAGE_NUMBER = 0;

export const COLORS_MAPPING = {
  Paid: 'green',
  Broken: 'red',
  Future: 'blue',
  Today: 'orange'
};

export const rowIndexZeroStyles = {
  fontWeight: 500,
  background: 'var(--navigation-blue-background-primary)',
  color: 'var(--blue-dark-cyan)'
};

export const alternativeColorStyles = {
  background: 'var(--ghost-white)',
  fontWeight: 'normal'
};

export interface IColumn {
  serverSort: string | null;
  field: string;
}
